module.exports = __webpack_public_path__ + "3dfe3ce56d2940b0fe8754ae9e6fa407.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-15.png
// module id = 3091
// module chunks = 0